export enum AlertLevel {
	Success = "Success",
	Warning = "Warning",
	Error = "Error"
}
